import React, { useEffect } from "react";
import "./LaundryPrice.css";
import ServiceAccordion from "../ServiceAccordion/ServiceAccordion";
import WhyChooseUs from "../../Pages/LaundryPrice/WhyChooseUs/WhyChooseUs";
import LaundryPricing from "../Maxima/LaundryPricing/LaundryPricing";
import ServicesCards from "../Offerlaundry/OffersPromotions/Services Cards/ServicesCards";

import AOS from "aos";
import "aos/dist/aos.css";
const serveotp = "/images/Services/OIPs.jpg";
export default function LaundryPrice() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  const DirhamIcon = () => (
    <svg width="14" height="14" viewBox="0 0 100 100">
      <path
        d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
        stroke="white"
        strokeWidth="10"
        fill="none"
      />
      <line x1="20" y1="40" x2="100" y2="40" stroke="white" strokeWidth="10" />
      <line x1="20" y1="60" x2="100" y2="60" stroke="white" strokeWidth="10" />
    </svg>
  );
  return (
    <div>
      <section className="laundry-price-section mt-4">
        <div className="laundry-container mt-5">
          {/* LEFT IMAGES */}
          <div className="image-section mt-5" data-aos="fade-right">
            <img
              src={serveotp}
              alt="Mobile App"
              className="image-image-large"
            />
          </div>
          {/* RIGHT CONTENT */}
          <div
            className="content-section"
            data-aos="fade-up"
            data-aos-delay="200"
          >
           <h2 className="mt-4">Transparent Pricing</h2>
<p className="description">
  We are committed to offering consistent, transparent, and fair prices
  to our customers. Our garments are priced according to their
  approximate weight and dimensions, along with the usual complexity
  of the fabric and the service required.
</p>

<ul className="price-listlaundryprice">
  <li>All prices are exclusive of 5% VAT.</li>

  <li>
    A flat service charge of  25.00  <DirhamIcon /> applies to all orders,
    regardless of the number of items.
  </li>

  <li>
    Minimum order value is  25.00 <DirhamIcon /> This will be updated to{" "}
     50.00 <DirhamIcon /> in the future.
  </li>

  <li>
    All prices are in <DirhamIcon />
  </li>
</ul>
         
            <div className="button-group">
              {/* WhatsApp Button */}
             <div className="order-buttons">
  {/* WhatsApp Button */}
  <a
    href="https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup."
    target="_blank"
    rel="noopener noreferrer"
    className="order-btn whatsapp-btn"
  >
    <i className="fab fa-whatsapp"></i> Order via WhatsApp
  </a>

  {/* Phone Button */}
  <a
    href="tel:+971545718455"
    className="order-btn phone-btn"
  >
    📞 Order via Phone
  </a>
</div>
            </div>
          </div>
        </div>
      </section>

      <div data-aos="fade-up">
        <WhyChooseUs />
      </div>

      {/* <div data-aos="fade-up">
        <LaundryPricing />
      </div> */}

         <div data-aos="fade-up">
        <ServiceAccordion/>
      </div>

      <div data-aos="fade-up">
        <ServicesCards />
      </div>
    </div>
  );
}
